import { SportName } from '@/../types/enums/sports';
import { AccessControlledModel } from '../AccessControlledModel';
import { ClipCategoryModel } from './ClipCategoryModel';

export class VideoClipCategoriesModel extends AccessControlledModel {
  sportName: SportName = SportName.Soccer
  collectionName: string = "default";
  clipCategories: ClipCategoryModel[] = [];
}